import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import PermissionsComponent from './permissions.component';

let PermissionsModule = angular
  .module('Permissions', [
    uiRouter
  ])
  .component('permissions', PermissionsComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state("permissions", {
      url: '/permissions',
      data: {
        authRequired: true,
        permsRequired: ['manage-perm', 'invite-user', 'view-profiles']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'permissions'
        }
      }

    })
  })
  .name;

export default PermissionsModule;



// WEBPACK FOOTER //
// ./src/app/pages/permissions/permissions.module.js